/**
 * Create config common to scatterplot chart types
 */
export var createScatterplotConfig = function (options) {
    return {
        axis: {
            // Horizontal and vertical grid lines
            grid: true
        },
        axisY: {
            // Default the Y axis to left orientation
            orient: 'left',
            labelAlign: 'right',
            // Include domain line
            domain: true
        },
        point: {
            // Default to solid shapes
            filled: true
        }
    };
};
